module.exports = __webpack_public_path__ + "static/fonts/NotoSansCJKkr-Bold.c55df3d.woff";


//////////////////
// WEBPACK FOOTER
// ./src/views/couponsys/assets/fonts/NotoSansCJKkr-Bold.woff
// module id = 1SrE
// module chunks = 0